import { render, staticRenderFns } from "./OVReceipts.vue?vue&type=template&id=e6449808&lang=pug"
import script from "./OVReceipts.vue?vue&type=script&lang=js"
export * from "./OVReceipts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports